import React from 'react';

import GraphqlProvider from './graphqlProvider';
import Root from '../../../StyledComponents/Root';
import SettingsProvider from '../State/Settings/SettingsProvider';
import RelatedSearchProvider from '../State/RelatedSearch/RelatedSearchProvider';
import CentralStorageProvider from '../State/CentralStorage/CentralStorageProvider';
import { PublicApiProps, resolvePublicApi } from '../../../Gql/config';

export interface EcomSettings {
  url: string;
  useBankId?: boolean;
  displayBankIdAlert?: boolean;
  serviceLogotypeUrl?: string;
  bankIdThumbprint?: string;
}

export type WaykeItemProviderSettings = PublicApiProps & {
  url: string;
  urlMlt?: string;
  graphQlUrl: string;
  apiKey?: string;
  ecomSettings?: EcomSettings;
  googleMapsApiKey?: string;
  googleMapsMarker?: string;
};

export type WaykeItemProviderProps = WaykeItemProviderSettings & {
  children?: React.ReactNode;
};

const WaykeItemProvider = ({
  url,
  urlMlt,
  apiKey,
  ecomSettings,
  graphQlUrl,
  googleMapsApiKey,
  googleMapsMarker,
  publicApiUrl,
  branchGroupId,
  children,
}: WaykeItemProviderProps) => {
  const publicApi = resolvePublicApi({ publicApiUrl, branchGroupId, apiKey });
  return (
    <SettingsProvider
      googleMapsApiKey={googleMapsApiKey}
      googleMapsMarker={googleMapsMarker}
      ecomSettings={ecomSettings}
      apiUrl={url}
      publicApi={publicApi}
    >
      <CentralStorageProvider>
        <GraphqlProvider uri={graphQlUrl}>
          <RelatedSearchProvider url={url} urlMlt={urlMlt} apiKey={apiKey}>
            <Root>{children}</Root>
          </RelatedSearchProvider>
        </GraphqlProvider>
      </CentralStorageProvider>
    </SettingsProvider>
  );
};

export default WaykeItemProvider;
